import React, { useEffect, useState } from 'react';
import { Grid, Paper, Dialog, Typography, withStyles } from '@material-ui/core';
import { getDownloadButtons, checkAvailableKeys, checkIfAvailable, alternativeDownloads, styles } from './DownloadPage';
import { snackActions } from '../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../sc-utilities';
import AppLogoLoading from '../sc-logo';
import { connect } from 'react-redux';

const downloadButtons = (translations) => [
    { downloadKey: 'remote_win', name: translations['remote_win'] || 'Windows' },
    { downloadKey: 'remote_win_msi', name: translations['remote_win_msi'] || 'Windows MSI' },
    { downloadKey: 'remote_win_intune', name: translations['remote_win_intune'] || 'Windows Intune' },
    { downloadKey: 'remote_osx', name: translations['remote_osx'] || 'macOS' },
];

export const icon = (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill="#7485FF"
            d="M30.5644 14.7384L30.7478 14.6161L30.4421 0H23.9625L24.0236 2.75198H18.3998V0.0611551H12.4091V2.81314H6.96868L7.09094 0H0.855803L0 29.2933L6.96868 33.2072L18.522 24.1563L24.6349 33.0238L29.892 29.9049L23.2901 20.487L24.1459 19.8143L30.5644 14.7384ZM15.0988 19.2639L6.05175 26.2356L6.54078 8.56172H7.76335L13.3872 16.6954L18.2164 12.9649L15.2211 8.56172L24.696 8.62288L24.8183 11.7418L24.3904 12.1087L15.0988 19.2639Z"
        />
    </svg>
);

const Remote = (props) => {
    const { classes, translations, permissions, activeCustomerID } = props;
    const [availableKeys, setAvailableKeys] = useState();
    const [privateAvailableKeys, setPrivateAvailableKeys] = useState();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchKeys = async () => {
            const res = await checkAvailableKeys(activeCustomerID).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            const privateRes = await checkAvailableKeys(activeCustomerID, false).catch((err) => {
                setLoading(false);
                snackActions.snackBarComponent(translations['request_failed'] || `Request failed`, 'error');
            });
            if (res?.status === 200 && privateRes?.status === 200) {
                setAvailableKeys(res.data.result.data);
                setPrivateAvailableKeys(privateRes.data.result.data);
            }
            setLoading(false);
        };
        fetchKeys();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [translations]);

    return (
        <Paper className={classes.root}>
            {hasPermission(permissions, 'binary_image_download') && (
                <>
                    <div className={classes.customToolbar}>
                        <div className={classes.tableTitle}>
                            {BackButton(translations, classes.customTooltip)}
                            <Typography className={classes.typography}>
                                {translations['downloads'] || 'Downloads'}
                            </Typography>
                        </div>
                    </div>
                    {!loading && (
                        <>
                            <Grid container direction="row" className={classes.grid}>
                                <Grid item ms={12} lg={6}>
                                    <h2>
                                        {icon} Remote{' '}
                                        {classes.latestVersionSpan && (
                                            <span className={classes.latestVersionSpan}>
                                                - {translations['latest_version'] || 'Latest Version'}
                                            </span>
                                        )}
                                    </h2>
                                    <p>
                                        {translations['remote_download_page'] ||
                                            'Tool for remote erasure of data on Windows devices by system administrators.'}
                                    </p>
                                </Grid>
                                <Grid item ms={6} lg={6} container direction="row" justify="center" alignItems="center">
                                    {getDownloadButtons(
                                        downloadButtons(translations),
                                        availableKeys,
                                        classes,
                                        privateAvailableKeys
                                    )}
                                    {checkIfAvailable(
                                        availableKeys,
                                        downloadButtons(translations),
                                        alternativeDownloads,
                                        classes,
                                        translations,
                                        privateAvailableKeys
                                    )}
                                </Grid>
                            </Grid>
                        </>
                    )}
                    <Dialog
                        disableBackdropClick={true}
                        disableEscapeKeyDown={false}
                        open={loading}
                        PaperProps={{
                            classes: {
                                root: classes.loadingScreen,
                            },
                        }}
                    >
                        <AppLogoLoading />
                    </Dialog>
                </>
            )}
        </Paper>
    );
};

const mapStateToProps = (state) => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations:
            state.translate && state.translate.translations
                ? state.translate.translations.activeTranslations || {}
                : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

export default connect(mapStateToProps, null)(withStyles(styles, { withTheme: true })(Remote));
